import { DateRange } from "@/components/controls/DateRangePicker";

export const ensureDate = (
  dateValue: Date | string | null | undefined
): Date | null => {
  if (!dateValue) return null;
  if (dateValue instanceof Date) return dateValue;
  if (typeof dateValue === "string") {
    const parsed = new Date(dateValue);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};

export const normalizeDateRange = (range: any): DateRange | null => {
  if (!range || typeof range !== "object") return null;

  const fromDate = ensureDate(range.fromDate);
  if (!fromDate) return null;

  const toDate = ensureDate(range.toDate);

  return {
    fromDate,
    toDate: toDate || undefined
  };
};

export const ensureDateForPicker = (
  dateValue: Date | string | null | undefined
): Date | undefined => {
  const date = ensureDate(dateValue);
  return date || undefined;
};
